import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			aboutAboutHeliumFusionContentSectionHeaderCls: string;
			aboutAboutHeliumFusionContentSectionSubheaderCustomCls: string;
			aboutAboutHeliumFusionContentSectionTextInnerCls: string;
		}
	},

	slug: string
}

class Fusion extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('About About Helium Fusion Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutAboutHeliumFusionContentSectionHeaderCls || '','about_about_helium_fusion', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutAboutHeliumFusionContentSectionSubheaderCustomCls || '','about_about_helium_fusion', { animCls: 'animate__fadeInDown', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutAboutHeliumFusionContentSectionTextInnerCls || '','about_about_helium_fusion', { animCls: 'animate__fadeInRight25P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Fusion;